import {Component, OnInit} from '@angular/core';
import {AuthTokenService} from '../../../shared/services/auth-token.service';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/pairwise';
import {SidebarService} from '../../../shared/services/sidebar.service';
import { ClientsService } from '../clients.service';
import { LicenseTierModel } from '../../../models/license-tier/license-tier.model';
import { ClientEnum, ClientModel } from '../../../models/survey/survey.model';
import { NewClientComponent } from '../new-client/new-client.component';
import * as _ from 'lodash';

@Component({
  selector: 'app-edit-client',
  templateUrl: './../new-client/new-client.component.html',
  styleUrls: ['./../new-client/new-client.component.less']
})
export class EditClientComponent extends NewClientComponent implements OnInit {

  licenseTiers: LicenseTierModel[];
  clientForm: FormGroup;
  dropdownLabel: string;
  licenseTierId?: number;
  clientId: number;
  client: ClientModel;
  showDeleteClientConfirm = false;
  checked = true;
  loader = false;
  isInternal = false;
  isLicenseTierInternal = false;

  constructor(protected clientsService: ClientsService,
              protected fb: FormBuilder,
              protected sidebarService: SidebarService,
              protected router: Router,
              protected route: ActivatedRoute) {
    super(clientsService, fb, sidebarService, router);
    this.route.params.subscribe();
    this.clientId = parseInt(this.route.snapshot.paramMap.get('id'), 0);
  }

  ngOnInit() {
    if (!AuthTokenService.isAdmin() || this.clientId === 0 || Number.isNaN(this.clientId)) {
      this.router.navigate(['/surveys']);
    }

    this.clientsService.getClient(this.clientId).subscribe(
        (response) => {
          if (!response) {
            this.router.navigate(['/surveys']);
          }

          this.client = response;
          this.updateForm();
          this.getLicenseTier();
        },
        (error) => {
        }
    );

    this.clientForm.get('allowImportTypeForm').valueChanges.subscribe(val => {
        if (val) {
          this.clientForm.controls['typeFormToken'].setValidators([Validators.required, Validators.maxLength(255)]);
          this.clientForm.controls['typeFormToken'].enable({ emitEvent: false });
        } else {
          this.clientForm.controls['typeFormToken'].clearValidators();
          this.clientForm.controls['typeFormToken'].disable({ emitEvent: false });
        }
        this.clientForm.controls['typeFormToken'].updateValueAndValidity();
    });

    this.clientForm.get('surveyMonkeyActivated').valueChanges.subscribe(val => {
        if (val) {
          this.clientForm.controls['surveyMonkeyToken'].setValidators([Validators.required, Validators.maxLength(255)]);
          this.clientForm.controls['surveyMonkeyToken'].enable({ emitEvent: false });
        } else {
          this.clientForm.controls['surveyMonkeyToken'].clearValidators();
          this.clientForm.controls['surveyMonkeyToken'].disable({ emitEvent: false });
        }
        this.clientForm.controls['surveyMonkeyToken'].updateValueAndValidity();
    });
  }

  onSave() {
    if (this.clientForm.valid) {
      let client = new ClientModel();
      client.id = this.clientId;
      client.active = this.clientForm.controls['active'].value;
      client.name = this.clientForm.controls['name'].value;
      client.licenseTierId = this.licenseTierId;
      if (this.clientForm.controls['expiryDate'].value !== null) {
        client.expiryDate = new Date(this.clientForm.controls['expiryDate'].value).toLocaleDateString();
      }
      client.typeFormActivated = this.clientForm.controls['allowImportTypeForm'].value;
      client.typeFormToken = this.clientForm.controls['typeFormToken'].value;
      client.surveyMonkeyActivated = this.clientForm.controls['surveyMonkeyActivated'].value;
      client.surveyMonkeyToken = this.clientForm.controls['surveyMonkeyToken'].value;
      this.clientsService.save(client).subscribe(
        (response) => {
          this.router.navigate(['/clients']);
        },
        (error) => {
        }
      );
    }
  }

  onDelete() {
    this.checked = true;
    this.showDeleteClientConfirm = true;
  }

  onDeleteClient() {
    this.loader = true;
    this.clientsService.delete(this.clientId).subscribe(
        (response) => {
            this.loader = false;
            this.router.navigate(['/clients']);
        },
        (error) => {
            this.loader = false;
        }
    );
  }

  updateForm() {
    this.clientForm.controls['active'].setValue(this.client.active);
    this.clientForm.controls['name'].setValue(this.client.name);
    this.licenseTierId = this.client.licenseTierId;
    this.clientForm.controls['expiryDate'].setValue(this.client.expiryDate);
    this.clientForm.controls['allowImportTypeForm'].setValue(this.client.typeFormActivated);
    this.clientForm.controls['typeFormToken'].setValue(this.client.typeFormToken);
    this.clientForm.controls['surveyMonkeyActivated'].setValue(this.client.surveyMonkeyActivated);
    this.clientForm.controls['surveyMonkeyToken'].setValue(this.client.surveyMonkeyToken);
  }

  onKeyupClientName(e: any) {
    if (e.target.value !== '') {
        this.clientsService.getClientName(e.target.value, this.client.id).subscribe(res => {
            if (res !== null) {
                this.clientForm.controls['name'].setErrors({'existing': true})
            }
        }, err => {
        });
    }
  }

  private getLicenseTier() {
    this.clientsService.getAllLicenseTier().subscribe(
        (response) => {
          this.licenseTiers = response;
          const licenseTier = this.licenseTiers.find(m => {
            return m.id === this.client.licenseTierId;
          })
          if (licenseTier) {
            this.isInternal = licenseTier.name === ClientEnum.INTERNAL;
            this.isLicenseTierInternal = this.isInternal;
            if (!this.isInternal) {
              this.licenseTiers = _.filter(this.licenseTiers, function(o) {
                return o.name !== ClientEnum.INTERNAL;
              });
            }
            this.licenseTierId = licenseTier.id;
            this.dropdownLabel = licenseTier.name;
            this.isAllowImportSurveyMonkey = licenseTier.allowImportSurveyMonkey;
            this.isAllowImportTypeForm = licenseTier.allowImportTypeForm;
          }
        },
        (error) => {
        }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/routes/clients/edit-client/edit-client.component.ts